import React from "react";
import { Table } from "antd";
import I18n from "../../common/I18n";
import { checkIncomingDataType, getConfigKey, getRowClassNameForAcc } from "../AllOrgActivities/helper";
import { Typography } from "antd";
const { Text } = Typography;


const ModifiedActivitiesList = ({ data }) => {
  const columns = [
    {
      key: "setting_name",
      title: <b>{I18n.t("orgActivities.setting_name")}</b>,
      dataIndex: "setting_name",
      render: (data, record) => (
        <span>{getConfigKey(data)}</span>
      ),
      width: 140,
    },
    {
      key: "old_value",
      title: <b>{I18n.t("orgActivities.old_value")}</b>,
      dataIndex: "old_value",
      render: (data) => <span>{checkIncomingDataType(data)}</span>,
      width: 120,
    },
    {
      key: "new_value",
      title: <b>{I18n.t("orgActivities.new_value")}</b>,
      dataIndex: "new_value",
      render: (data, record) => (
        <span
          style={{
            backgroundColor: !["N/A", "n/a", undefined, null, NaN, ""].includes(record?.old_value)
              ? "yellow"
              : null,
          }}
        >
          {checkIncomingDataType(data)}
        </span>
      ),
      width: 120,
    },
  ];

  // Function to render expanded row content
  const expandedRowRender = (record) => {
    const childData = _.find(data, { key: record.key })?.children || [];
    if (childData.length === 0) return null;

    const oldValues = childData[0]?.old_value || [];
    const newValues = childData[0]?.new_value || [];

    const detailColumns = [
      {
        key: "code",
        title: <b>Code</b>,
        dataIndex: "code",
      },
      {
        key: "mandatory",
        title: <b>Mandatory</b>,
        dataIndex: "mandatory",
        render: (data) => (Array.isArray(data) && !_.isEmpty(data) ? data.join(", ") : <Text type="secondary">N/A</Text>),
      },
      {
        key: "required_for",
        title: <b>Required For</b>,
        dataIndex: "required_for",
      },
    ];

    return (
      <div>
        {oldValues.length > 0 && (
          <div style={{ marginBottom: "10px" }}>
            <b>Old Values</b>
            <Table
              columns={detailColumns}
              dataSource={oldValues.map((item, index) => ({
                ...item,
                key: `old_${index}`,
              }))}
              rowKey="key"
              pagination={false}
              bordered
              size="small"
              rowClassName={(record) => {
                const oldValues = childData[0]?.old_value || [];
                const newValues = childData[0]?.new_value || [];
                  return getRowClassNameForAcc(record, oldValues, newValues, true);
              }}
            />
          </div>
        )}

        {newValues.length > 0 && (
          <div>
            <b>New Values</b>
            <Table
              columns={detailColumns}
              dataSource={newValues.map((item, index) => ({
                ...item,
                key: `new_${index}`,
              }))}
              rowKey="key"
              pagination={false}
              bordered
              size="small"
              rowClassName={(record) => {
                const oldValues = childData[0]?.old_value || [];
                const newValues = childData[0]?.new_value || [];
                  return getRowClassNameForAcc(record, oldValues, newValues, false);
              }}
            />
          </div>
        )}
      </div>
    );
  };

  const mainTableData = _.map(data, (record) => _.omit(record, ["children"]));
    return (
    <Table
      columns={columns}
      className="custom-nested-table"
      dataSource={mainTableData}
      rowKey="key"
      expandedRowRender={expandedRowRender}
      expandIcon={({ expanded, onExpand, record }) =>
        record.setting_name === "pod_pic_settings" ? (
          <span
            onClick={(e) => onExpand(record, e)}
            className={`ant-table-row-expand-icon ${
              expanded
                ? "ant-table-row-expanded"
                : "ant-table-row-collapsed"
            }`}
            style={{ cursor: "pointer" }}
          ></span>
        ) : null
      }
      pagination={false}
      bordered
    />
  );
};

export default ModifiedActivitiesList;
